import { useContext } from 'react';
import { EscalationModalContext } from '.';

export const useEscalationModal = () => {
    const escalationModalContext = useContext(EscalationModalContext);
    return escalationModalContext;
};
